import React from "react";
import { Card } from "@/components/ui/card";
import { SectionHeader } from "@/components/common/Widgets";
import ThemeSwitcher from "@/components/common/ThemeSwitcher";
import Google2FACard from "@/components/common/Google2FACard";
import { useAuth } from "@/lib/auth";

export default function SettingsPage() {
  const { user } = useAuth();
  return (
    <div className="space-y-5 max-w-5xl">
      <SectionHeader title="Settings" subtitle="Manage your profile, security and appearance preferences." />

      <Card className="p-5">
        <div className="text-sm font-semibold heading mb-3">Profile</div>
        <div className="grid grid-cols-2 md:grid-cols-4 gap-3 text-sm">
          <KV k="Name" v={user?.name} />
          <KV k="Email" v={user?.email} />
          <KV k="Role" v={user?.role} />
          <KV k="Branch" v={user?.branch} />
        </div>
      </Card>

      <Google2FACard />

      <Card className="p-5">
        <div className="text-sm font-semibold heading mb-1">Appearance</div>
        <p className="text-xs text-muted-foreground mb-3">Theme, accent colour and font scale. Saffron applies the Indian national palette.</p>
        <ThemeSwitcher />
      </Card>
    </div>
  );
}
function KV({ k, v }) {
  return (<div><div className="text-xs uppercase tracking-wide text-muted-foreground font-medium">{k}</div><div className="text-sm mt-0.5">{v || "—"}</div></div>);
}
